import React, { useEffect, useState } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ThemeProvider } from 'styled-components'

import AlertGlobal from './components/Mantine/Alert'
import NotificationGlobal from './components/Mantine/Notification'
import SpinnerGlobal from './components/spinnerVeye/spinnerGlobal.jsx'
import { EstilosGlobais } from './css/global'
import { claroTema, escuroTema } from './css/temas'
import Routers from './routers'
import { useGlobal } from './stores/useGlobal'

const queryClient = new QueryClient()

const DEFAULT_THEMES = ['claro', 'escuro']

const getInitialTheme = () => {
  const temaAtual = localStorage.getItem('tema')
  if (!DEFAULT_THEMES.includes(temaAtual)) {
    localStorage.setItem('tema', 'claro')
    return claroTema
  }
  return temaAtual === 'escuro' ? escuroTema : claroTema
}

export default function App() {
  const toggleTema = useGlobal((state) => state.toggleTema)

  const [coresTema, setCoresTema] = useState(getInitialTheme)

  useEffect(() => {
    let temaAtual = localStorage.getItem('tema')

    if (!DEFAULT_THEMES.includes(temaAtual)) {
      temaAtual = 'claro'
      localStorage.setItem('tema', temaAtual)
    }

    setCoresTema(temaAtual === 'escuro' ? escuroTema : claroTema)
  }, [toggleTema])

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={coresTema}>
        <EstilosGlobais />
        <NotificationGlobal />
        <SpinnerGlobal />
        <AlertGlobal />
        <Routers />
      </ThemeProvider>
    </QueryClientProvider>
  )
}
